export default "__VITE_ASSET__77b2229c__"